/* eslint-disable no-undef */
import { IApps } from "types/applications.type";
import api from "./ApiService";

const getESystems = (data: any) => {
  return api
    .get<IApps>(
      process.env.REACT_APP_API_BASE_URL + `/external-systems?${data}`
    )
    .then((response: any) => {
      return response;
    });
};

const ExternalSystemService = {
  getESystems,
};
export default ExternalSystemService;
